export default {
  width: 360,
  height: 640,
}



// WEBPACK FOOTER //
// ./config.js